import React from "react"
import sanitizeHtml from "sanitize-html"

const Header = ({ name, description, children }) => {
  return (
    <header>
      <h1 className="h1">{name}</h1>
      {children}
      {description && (
        <div
          className="fs-3 c-tint0"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(description).replace(/\n/g, "<br />"),
          }}
        ></div>
      )}
    </header>
  )
}

export default Header
